import React, { PureComponent } from 'react';
import {
  SafeAreaView,
  StyleSheet, View, Text,
  ScrollView,
} from 'react-native';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { defaultScale } from '../../../../utils/scaling';
import { getNextStep, navigateToNextStep } from '../../../actions';
import { IAppStore } from '../../../../HomeWorkouts';
import { GoogleAnalytics } from '../../../../services/google-analytics';
import Theme from '../../../../theme';
import { UserDataConsumer } from '../../../../utils';
import { IConnectedAppOnboardingProps, navigateToNextOnboardingStep } from '../ConnectedAppEntryPointScreen';
import Coros from '../../../../assets/icons/connected-apps/suported-devices/coros.svg';
import Fitbit from '../../../../assets/icons/connected-apps/suported-devices/fitbit.svg';
import Garmin from '../../../../assets/icons/connected-apps/suported-devices/garmin.svg';
import Oppo from '../../../../assets/icons/connected-apps/suported-devices/oppo.svg';
import Polar from '../../../../assets/icons/connected-apps/suported-devices/polar.svg';
import Samsung from '../../../../assets/icons/connected-apps/suported-devices/samsung.svg';
import FooterButtons from './FooterButtons';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: defaultScale(16),
    backgroundColor: Theme.WHITE,
  },
  headerContainer: {
    alignItems: 'center',
    marginTop: '5%',
    textAlign: 'center',
    flex: 1,
  },
  heading: {
    textAlign: 'center',
    paddingHorizontal: defaultScale(30),
    marginBottom: defaultScale(20),
  },
  subHeader: {
    color: Theme.GREY_DARK_MEDIUM,
    marginBottom: defaultScale(10),
    paddingHorizontal: defaultScale(30),
    textAlign: 'center',
  },
  supportedDevicesContainer: {
    marginTop: defaultScale(10),
    marginBottom: defaultScale(10),
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: defaultScale(10),
  },
  deviceItem: {
    alignItems: 'center',
    paddingVertical: defaultScale(5),
  },
  scrollViewContainer: {
    position: 'relative',
    flex: 1,
  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: defaultScale(40),
    zIndex: 1,
  },
});

class SupportedDevices extends PureComponent<IConnectedAppOnboardingProps & WithTranslation> {
  private readonly googleAnalytics: GoogleAnalytics;

  public constructor(props: IConnectedAppOnboardingProps & WithTranslation) {
    super(props);
    this.googleAnalytics = new GoogleAnalytics();
  }

  public render() {
    const { t } = this.props;
    const deviceComponents = [Polar, Fitbit, Coros, Oppo, Garmin, Samsung];

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.headerContainer}>
          <Text style={[Theme.textStyle.heading, styles.heading]}>{t('enableAppleHealthOnYourDevicesApp')}</Text>
          <Text style={[Theme.textStyle.bodyCopyReg, styles.subHeader]}>
            {t('forSupportedDevices')}
          </Text>
          <View style={styles.supportedDevicesContainer}>
            <ScrollView contentContainerStyle={{ alignItems: 'center' }}>
              {deviceComponents.map((DeviceComponent) => (
                <View style={styles.deviceItem}>
                  <DeviceComponent />
                </View>
              ))}
            </ScrollView>
          </View>
        </View>
        <FooterButtons
          primaryButtonText={t('next')}
          onPrimaryButtonPress={() => this.proceedToNextStep()}
          isLoading={false}
        />
      </SafeAreaView>
    );
  }

  private proceedToNextStep = () => {
    navigateToNextOnboardingStep(
      this.props,
      this.props.getNextStep,
      this.props.navigateToNextStep,
    );
    this.googleAnalytics.logEventWithParamaters('sign_up_enable_apple_health_on_device', { enabled: true });
  };
}

const mapStateToProps = (state: IAppStore) => ({
  enabledFeatures: state.auth.signup.enabledFeatures,
});

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export default withTranslation(['auth', 'settings'])(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(SupportedDevices)),
);
